// Any scan is Maiden or Prescan depending on which is available
export interface IAnyScan {
  orthophotoTilesPath: string;
  // Null when the scan has no DEM, which is always the case for satellite maidens
  elevationMapTilesPath: string | null;
  // Satellite maidens have tiles of a lower resolution than the other scans
  isSatellite: boolean;
}

const ANY_SCAN_PERSISTED = "ANY_SCAN_PERSISTED";
export const persistAnyScan = (anyScan: IAnyScan) => ({
  type: ANY_SCAN_PERSISTED,
  payload: anyScan,
});

const ANY_SCAN_ELEVATION_MAP_TOGGLED = "ANY_SCAN_ELEVATION_MAP_TOGGLED";
export const toggleAnyScanElevationMap = () => ({
  type: ANY_SCAN_ELEVATION_MAP_TOGGLED,
});

export interface IAnyScanState {
  data: IAnyScan | null;
  isElevationMapVisible: boolean;
}

const defaultState: IAnyScanState = {
  data: null,
  isElevationMapVisible: false,
};

const maidenScanReducer = (
  state: IAnyScanState = defaultState,
  action: IAction<any>,
) => {
  switch (action.type) {
    case ANY_SCAN_PERSISTED:
      return {
        ...state,
        data: action.payload,
      };
    case ANY_SCAN_ELEVATION_MAP_TOGGLED:
      return {
        ...state,
        isElevationMapVisible: !state.isElevationMapVisible,
      };
    default:
      return state;
  }
};

export default maidenScanReducer;
